export interface IHistoryAction<T> {
    date: Date;
    action: HistoryActionType;
    meta?: T;
}

// successful share
export const SharedWithUsers = 'shared-with-users';

export interface ISharedWithUserIdActionMeta {
    userId: string;
    name: string;
    email: string;
}

export interface ISharedWithUserActionMeta {
    userId: string;
    name: string;
    email: string;
}

export interface ISharedWithUsersHistoryAction extends IHistoryAction<ISharedWithUserActionMeta[]> {
    action: typeof SharedWithUsers;
}

// failed share
export const FailedToShareWithUsers = 'failed-to-share-with-users';
export const FailedToShareWithMissingUsers = 'failed-to-share-with-missing-users';

export interface IErrorActionMeta {
    error: string;
}

export interface IFailedToShareWithUserActionMeta extends ISharedWithUserActionMeta, IErrorActionMeta {}

export interface IMissingUsersActionMeta extends IErrorActionMeta {
    missingUserIds: string[];
}

export interface IFailedToShareWithUsersHistoryAction extends IHistoryAction<IFailedToShareWithUserActionMeta[]> {
    action: typeof FailedToShareWithUsers;
}

export interface IFailedToSharedWithMissingUsersHistoryAction extends IHistoryAction<IMissingUsersActionMeta> {
    action: typeof FailedToShareWithMissingUsers;
}

export const HistoryActions = [SharedWithUsers, FailedToShareWithUsers, FailedToShareWithMissingUsers] as const;
export type HistoryActionType = typeof HistoryActions[number];
export type HistoryAction =
    | ISharedWithUsersHistoryAction
    | IFailedToShareWithUsersHistoryAction
    | IFailedToSharedWithMissingUsersHistoryAction;
